export default class City {
  /**
   *
   * @param {Object} CityObject param0 | Api response
   * @param {String} CityObject.city_id unique id of the city
   * @param {String} CityObject.city Name of the city
   * @param {String} CityObject.state State corresponding to the city
   * @param {Array[Array[Number, Number]]} CityObject.bbox geometric bounding-box of the city
   * @param {[Number,Number]} CityObject.latlong [latitude, langitude] of the city
   * @param {Number} CityObject.zoom zoom level for the city
   */
  constructor({ city_id, city, state, bbox, latlong, zoom }) {
    this.id = city_id;
    this.name = city;
    this.state = state;
    this.bbox = bbox;
    this.latlong = latlong;
    this.zoom = zoom;
  }

  /**
   * Method to calclulate the centroid of a given geometry
   * Algo: The average of latitude and longitude
   */
  getCentroid() {
    // calculate the centroid of the geometry
    let centroid = this.bbox
      .reduce((prev, next) => {
        return [prev[0] + next[0], prev[1] + next[1]];
      })
      .map(item => Math.floor(item / this.bbox.length));
    return centroid;
  }
}
